import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PATH } from '../enums/routes.enum';
import { catchError, map, of } from 'rxjs';
import { RegisterStore } from '../../features/register/store/register.store';

export const RegisterGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const store = inject(RegisterStore);
  const token = route.queryParamMap.get('token');

  if (!token) {
    router.navigate([PATH.LOGIN]);
    return false;
  }
  return store.getUserInformation(token).pipe(
    map(() => !!store.user()),
    catchError(() => {
      router.navigate([PATH.LOGIN]);
      return of(false);
    }),
  );
};
